import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface xiaohongshuWebMsgReadParams extends ActiomCommonParams {
    type: "mentions" | "likes" | "connections"; // 消息类型
}
export interface ReadResponse {
    code: number;
    success: boolean;
    msg: string;
}

export type PublishAction = CommonAction<xiaohongshuWebMsgReadParams, ReadResponse | Record<string, never>>;

export const xiaohongshuWebMsgRead: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(414, "Read指定Tab失败", {});

    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com/",
    };

    const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: [] };
    if (!params.type) {
        return { code: 414, message: "参数缺失，请检查后重试！", data: {} };
    }

    const replyParams = {
        type: params.type,
    };

    const fatchMentions = "/api/sns/web/v1/message/read";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const fatchMentionsXsHeader = xsEncrypt.signHeadersPost(fatchMentions, recordCookie, "xhs-pc-web", replyParams);

    const res = await http.api<ReadResponse>(
        {
            method: "post",
            url: "https://edith.xiaohongshu.com/api/sns/web/v1/message/read",
            data: replyParams,
            headers: fatchMentionsXsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    const message = `Read指定Tab${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.success : {};

    return response(isSuccess ? 0 : 414, message, data);
};
